import Swiper from 'swiper/bundle';

const MediaColumns = () => {
  const sliders = document.querySelectorAll('.media-columns__swiper');
  if (!sliders.length) return;

  const swiperInstances = new WeakMap();

  const initOrDestroySwiper = () => {
    sliders.forEach((slider) => {
      if (!(slider instanceof Element)) return;

      const slides = slider.querySelectorAll('.swiper-slide');
      const existingSwiper = swiperInstances.get(slider);

      const shouldDestroy =
        window.innerWidth >= 1024 && slides.length <= 4;

      if (shouldDestroy && existingSwiper) {
        existingSwiper.destroy(true, true);
        swiperInstances.delete(slider);
        return;
      }

      if (!shouldDestroy && !existingSwiper) {
        const swiper = new Swiper(slider, {
          slidesPerView: 'auto',
          spaceBetween: 20,
          loop: false,
          pagination: {
            el: slider.querySelector('.media-columns__pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: slider.querySelector('.media-columns__nav--next'),
            prevEl: slider.querySelector('.media-columns__nav--prev'),
          },
          breakpoints: {
            1024: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
          },
        });

        swiperInstances.set(slider, swiper);
      }
    });
  };

  // Initial load
  initOrDestroySwiper();

  // Responsive check
  window.addEventListener('resize', () => {
    initOrDestroySwiper();
  });
};

export default MediaColumns;
